import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import { toast } from "react-toastify";
import { uwinAPI } from "../../../services/uwin.api";
import { Linkedchildren } from "../components/Linkedchildren";
import UpdateHbValue from "./UpdateHbValue";
import PregnancyOutCome from "./PregnancyOutCome/PregnancyOutCome";
import DeclarePregnancy from "./DeclarePregnancy";
import ViewPregnancyDetails from "./PregnancyOutCome/ViewPregnancyDetails";
import NewbornRegistration from "./NewbornRegistration";
import RoutineVaccinationSection from "./routineVaccination/RoutineVaccinationSection";
import {
	calculateAge,
	decryptOpenSSLAES,
	isTestingDateOlderThan30Days,
} from "../../../helpers/common-uwinhelper";

export const Vaccinationuwin = ({
	onClose,
	benProfileData,
	handleCloseLinkedChildren,
}) => {
	const [profileData, setProfileData] = useState([]);
	const [childProfileData, setChildProfileData] = useState(null);
	const [vaccinations, setVaccinations] = useState([]);
	const [isPageLoading, setIsPageLoading] = useState(false);
	const [pregnancyDetails, setPregnancyDetails] = useState(null);
	const [showLinkedProfile, setShowLinkedProfile] = useState(false);
	const [showUpdateHbValue, setShowUpdateHbValue] = useState(false);
	const [HBTestingDate, setHBTestingDate] = useState("");

	const [showPregnancyModal, setShowPregnancyModal] = React.useState(false);
	const [viewPregnancyDetailsModal, setViewPregnancyDetailsModal] =
		React.useState(false);
	const [isNewbornRegistrationActive, setIsNewbornRegistrationActive] =
		React.useState(false);
	const [pregnancyOutcomeData, setPregnancyOutcomeData] = React.useState({});
	const [declarePregnancyModal, setDeclarePregnancyModal] =
		React.useState(false);
	const [selectedPregnancyIndex, setSelectedPregnancyIndex] =
		React.useState(null);

	const encryptText = async (plaintext) => {
		try {
			const payload = {
				plaintext: plaintext,
			};
			// Fetch the parent profile data
			const resEncrypt = await uwinAPI.encryptText(payload);
			return resEncrypt.data.encrypted;
		} catch (error) {
			console.error("Backend login error:", error);
		}
	};

	const getPregnancyData = async () => {
		setIsPageLoading(true);
		try {
			const payload = {
				beneficiary_id: benProfileData.beneficiary_id,
			};
			// Fetch the parent profile data
			const pregnancy_details = await uwinAPI.getPregnancyDetails(payload);
			if (pregnancy_details.success) {
				setIsPageLoading(false);
				setPregnancyDetails(pregnancy_details.data);
			} else {
				setIsPageLoading(false);
				toast.error("No pregnancy details found");
			}
		} catch (error) {
			setIsPageLoading(false);
			toast.error("Error fetching pregnancy details");
		} finally {
			setIsPageLoading(false);
		}
	};

	const getChildProfiles = async (data) => {
		if (!data?.linkedmembers) return [];

		const parentId = data.beneficiary_id; // guardian_ben_id will match this

		const childProfiles = data.linkedmembers.filter(
			(item) =>
				(item.beneficiary_type_name === "Children" ||
					item.beneficiary_type_name === "Infant" ||
					item.beneficiary_type_name === "New Born Baby") &&
				item.guardian_ben_id === parentId
		);

		return childProfiles;
	};

	const getBeneficiaryProfile = async () => {
		setIsPageLoading(true);
		try {
			const payload = {
				beneficiary_id: await encryptText(benProfileData.beneficiary_id),
			};
			// Fetch the parent profile data
			const profileResponse = await uwinAPI.getBeneficiaryProfile(payload);
			if (profileResponse.success) {
				setIsPageLoading(false);
				setProfileData(profileResponse?.data);
				if (profileResponse?.data?.linkedmembers?.length > 0) {
					const childProfileData = await getChildProfiles(profileResponse?.data);
					if (childProfileData && childProfileData?.length > 0) {
						setShowLinkedProfile(true);
						setChildProfileData(childProfileData);
					}
				}
			} else {
				setIsPageLoading(false);
				toast.error("No vaccination data found");
			}
		} catch (error) {
			setIsPageLoading(false);
			toast.error("Error fetching vaccination data");
		} finally {
			setIsPageLoading(false);
		}
	};

	const getVaccinationData = async (beneficiary_reference_id, lmc_date) => {
		setIsPageLoading(true);
		try {
			const payload = {
				beneficiary_ref_id: beneficiary_reference_id,
			};
			if (lmc_date) {
				payload.lmc_date = lmc_date;
			}
			// Fetch the parent profile data
			const vaccineResponse = await uwinAPI.getVaccinations(payload);
			if (vaccineResponse.success) {
				setIsPageLoading(false);
				setVaccinations(vaccineResponse.data);
			} else {
				setIsPageLoading(false);
				toast.error("No vaccination data found");
			}
		} catch (error) {
			setIsPageLoading(false);
			toast.error("Error fetching vaccination data");
		} finally {
			setIsPageLoading(false);
		}
	};

	const handleComingSoon = () => {
		toast.info("Feature coming soon!");
	};

	useEffect(() => {
		getBeneficiaryProfile();
		if (
			benProfileData?.beneficiary_type_name != "Adolesant" && benProfileData?.beneficiary_type_name != "Citizen"
		) {
			const lmc_date = benProfileData?.lmc_date ? benProfileData.lmc_date : undefined;
			getVaccinationData(benProfileData.beneficiary_reference_id, lmc_date);
			if (benProfileData?.beneficiary_type_name == "Pregnant Woman") {
				getPregnancyData();
			}
		}
	}, [benProfileData]);

	const handleOpenUpdateHB = (profileData) => {
		setShowUpdateHbValue(true);
		setProfileData(profileData);
	};

	return (
		<>
			{isPageLoading && <Loader />}

			<div className="sickleMedicationSection">
				<div className=" mt-4">
					<div className="accordion" id="vaccinationAccordion">
						<div className="patientDetailsTitleHeader-h d-flex mb-0">
							<div className="leftHeaderBar">
								<h4>
									{" "}
									<span>
										<img
											src={"/images/uwin.svg"}
											alt=""
											style={{ width: "55px", margin: "10px" }}
										/>
									</span>{" "}
									Beneficiary Profile
								</h4>
							</div>
							<div
								className="closeDive close-uwin"
								onClick={() => onClose("handleCloseVaccinationUWIN")}
							>
								<img src={"/images/closing.svg"} alt="Close" />
							</div>
						</div>
						<section className="background-white-bg">
							<div>
								<div className="d-flex profile_chiled">
									<div className="d-flex flex-column flex-md-row gap-2 button_right-vacc">
										<>
											{/* Update Hb Value - hidden/disabled
											{isTestingDateOlderThan30Days(
												profileData?.hb_testing_date ? profileData?.hb_testing_date : HBTestingDate ? HBTestingDate : ""
											) && (
													<button
														className="mx-2 sickle-save-button"
														onClick={() => handleOpenUpdateHB(benProfileData)}
													>
														Update Hb Value
													</button>
												)}
											*/}

											{!benProfileData?.is_pregnant_woman &&
												benProfileData?.beneficiary_gender === "Female" &&
												calculateAge(benProfileData?.dob)?.age >= 12 &&
												calculateAge(benProfileData?.dob)?.age < 50 &&
												isTestingDateOlderThan30Days(benProfileData?.previous_pregnancy_year) && (
													<button
														className="mx-2 sickle-save-button"
														onClick={() => setDeclarePregnancyModal(true)}
													>
														Declare Pregnancy
													</button>
												)}
										</>
									</div>
								</div>
								<div className="row profile_chiled pregnent_women">
									<div className="col-12 col-md-6">
										<img
											src={"/images/user.png"}
											alt="Child"
											className="me-2"
										/>
										<span>{benProfileData?.ben_name}</span>
									</div>

									<div className="col-12 col-md-6 mt-2 mt-md-0">
										<span className="d-block d-md-inline">
											{benProfileData?.ben_mobile_number}
										</span>
										<span className="d-block d-md-inline ms-md-3">
											{calculateAge(benProfileData?.dob)?.ageText} (
											{benProfileData?.dob})
										</span>
									</div>
								</div>
								<div className="d-flex profile_chiled pregnent_women">
									<p>
										{" "}
										<span> {benProfileData?.beneficiary_gender} </span>{" "}
										<span className="boreder_right">
											{" "}
											{benProfileData?.beneficiary_type_name}
										</span>
									</p>
								</div>

								<div className="profile-info-wrapper">

									{benProfileData?.photo_id_type && benProfileData?.photo_id_number && (
										<div className="profile_child">
											<p className="profile_label">IDENTIFICATION</p>
											<p className="profile_value">
												<span>
													{decryptOpenSSLAES(benProfileData?.photo_id_type)}
												</span>
												<span className="border_right">
													{decryptOpenSSLAES(benProfileData?.photo_id_number)}
												</span>
											</p>
										</div>
									)}

									{vaccinations?.abha_number && (
										<div className="profile_child">
											<p className="profile_label">ABHA Number</p>
											<p className="profile_value">
												{vaccinations?.abha_number}
											</p>
										</div>
									)}

									{vaccinations?.lmc_date && (
										<div className="profile_child">
											<p className="profile_label">LMC Date</p>
											<p className="profile_value">
												{vaccinations?.lmc_date}
											</p>
										</div>
									)}

									{benProfileData?.previous_pregnancy_year && (
										<div className="profile_child">
											<p className="profile_label">
												DATE OF LAST PREGNANCY OUTCOME
											</p>
											<p className="profile_value">
												{benProfileData?.previous_pregnancy_year}
											</p>
										</div>
									)}

								</div>
							</div>
						</section>
						{/* Accordion 1 */}
						{/* {(benProfileData?.beneficiary_type_name == 'Preganent Women' || benProfileData?.beneficiary_type_name == 'Children') && ( */}

						<>
							{benProfileData?.beneficiary_type_name !== "Adolesant" &&
								benProfileData?.beneficiary_type_name !== "Citizen" && (
								<div className="accordion-item">
									<h2 className="accordion-header" id="headingOne">
										<button
											className="accordion-button collapsed fw-bold"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseOne"
										>
											Routine Vaccination
										</button>
									</h2>
									<div
										id="collapseOne"
										className="accordion-collapse collapse show"
										data-bs-parent="#vaccinationAccordion"
									>
										<div className="accordion-body">
											<RoutineVaccinationSection
												beneficiaryRow={benProfileData}
												vaccinationDetails={vaccinations?.vaccinationDetails}
												onVaccinationSaved={async () => {
													const lmc_date = benProfileData?.lmc_date
														? benProfileData.lmc_date
														: undefined;
													await getVaccinationData(
														benProfileData.beneficiary_reference_id,
														lmc_date
													);
												}}
											/>
										</div>
									</div>
								</div>
							)}
							{/* Accordion 2 */}
							{profileData?.lmc_date != "" &&
								pregnancyDetails &&
								pregnancyDetails?.length > 0 && (
									<div className="accordion-item">
										<h2 className="accordion-header" id="headingTwo">
											<button
												className="accordion-button collapsed fw-bold"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseTwo"
											>
												Pregnancy Details
											</button>
										</h2>
										<div
											id="collapseTwo"
											className="accordion-collapse collapse"
											data-bs-parent="#vaccinationAccordion"
										>
											<div className="accordion-body">
												{pregnancyDetails && pregnancyDetails?.length > 0 ? (
													pregnancyDetails.map((pregnancy, index) => (
														<div
															key={index}
															className="d-flex align-items-start justify-content-between flex-wrap gap-4 data-font-size"
														>
															<div>
																<div className="fw-bold mt-2">
																	PREGNANCY {pregnancy?.pregnancy_number}
																</div>
															</div>
															<div>
																<div className="fw-bold">
																	Last Menstrual Period
																</div>
																<div>{pregnancy?.lmc_date}</div>
															</div>
															<div>
																<div className="fw-bold">
																	Estimated Date of Delivery
																</div>
																<div>{pregnancy?.edd_date}</div>
															</div>
															<div>
																{pregnancy?.lmc_date !== "" ? (
																	<button
																		className="sickle-save-button mt-2"
																		onClick={() => {
																			setSelectedPregnancyIndex(index);
																			setShowPregnancyModal(true);
																		}}
																	>
																		UPDATE
																	</button>
																) : (
																	<button
																		className="sickle-save-button mt-2"
																		onClick={() => {
																			setSelectedPregnancyIndex(index);
																			setViewPregnancyDetailsModal(true);
																		}}
																	>
																		View
																	</button>
																)}
															</div>
														</div>
													))
												) : (
													<div>No pregnancy details available</div>
												)}
											</div>
										</div>
									</div>
								)}

						</>

						{isNewbornRegistrationActive && (
							<div className="accordion-item">
								<h2 className="accordion-header" id="headingThree">
									<button
										className="accordion-button collapsed fw-bold"
										type="button"
										data-bs-toggle="collapse"
										data-bs-target="#collapseThree"
									>
										Newborn Registration
									</button>
								</h2>
								<div
									id="collapseThree"
									className="accordion-collapse collapse"
									data-bs-parent="#vaccinationAccordion"
								>
									<div className="accordion-body">
										<NewbornRegistration
											pregnancyOutcomeData={pregnancyOutcomeData}
											benProfileData={benProfileData}
										/>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
			{showPregnancyModal && (
				<>
					<PregnancyOutCome
						isModalOpen={showPregnancyModal}
						isModalClose={() => {
							setShowPregnancyModal(false);
							setSelectedPregnancyIndex(null);
						}}
						pregnancyDetails={
							selectedPregnancyIndex !== null
								? pregnancyDetails[selectedPregnancyIndex]
								: null
						}
						latestVaccinationDate={vaccinations?.latest_vacc_date}
						setIsNewbornRegistrationActive={setIsNewbornRegistrationActive}
						setPregnancyOutcomeData={setPregnancyOutcomeData}
						getPregnancyData={getPregnancyData}
						benProfileData={benProfileData}
					/>
				</>
			)}
			{viewPregnancyDetailsModal && (
				<ViewPregnancyDetails
					isModalOpen={viewPregnancyDetailsModal}
					isModalClose={() => {
						setViewPregnancyDetailsModal(false);
						setSelectedPregnancyIndex(null);
					}}
					pregnancyDetails={
						selectedPregnancyIndex !== null
							? pregnancyDetails[selectedPregnancyIndex]
							: null
					}
					getPregnancyData={getPregnancyData}
				/>
			)}
			{declarePregnancyModal && (
				<DeclarePregnancy
					isModalOpen={declarePregnancyModal}
					isModalClose={() => {
						setDeclarePregnancyModal(false);
					}}
					benProfileData={benProfileData}
					profileData={profileData}
					getBeneficiaryProfile={getBeneficiaryProfile}
					getPregnancyData={getPregnancyData}
				/>
			)}
			{showLinkedProfile && (
				<Linkedchildren
					onClose={handleCloseLinkedChildren}
					childProfileData={childProfileData}
					setShowUpdateHbValue={setShowUpdateHbValue}
					setProfileData={setProfileData}
					benProfileData={benProfileData}
				/>
			)}

			{showUpdateHbValue && (
				<UpdateHbValue
					showUpdateHbValue={showUpdateHbValue}
					setShowUpdateHbValue={setShowUpdateHbValue}
					setHBTestingDate={setHBTestingDate}
					benProfileData={profileData}
				/>
			)}
		</>
	);
};
